export const scrollToFirstError = (fieldsWithError, fields) => {
  if (!fieldsWithError || !fields) {
    return;
  }

  // We need to step through fieldsWithError to guarantee ordering
  // (since redux-form returns an errors object, not array or map)
  Object.keys(fieldsWithError).map((field) => {
    if (fields.indexOf(field) > -1) {
      const elem = document.querySelector(`input[id=${field}], select[id=${field}]`);
      if (elem) {
        elem.focus();
      }
    }
    return field;
  });
};
